var _rect, _rect2, _path, _path2, _g, _path3, _g2, _g3, _path4, _path5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettinngsVersionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Version_32px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1223",
    "data-name": "Rectangle 1223",
    width: 30,
    height: 30,
    transform: "translate(1 1)",
    fill: "#fff",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M10.61,26.83H7.89a2.723,2.723,0,0,1-2.72-2.72V7.8A2.723,2.723,0,0,1,7.89,5.08H24.2A2.723,2.723,0,0,1,26.92,7.8V9.16H13.33a2.723,2.723,0,0,0-2.72,2.72Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M6.53,24.11H3.81a2.723,2.723,0,0,1-2.72-2.72V5.08A2.723,2.723,0,0,1,3.81,2.36H20.13a2.723,2.723,0,0,1,2.72,2.72V6.44H9.25A2.723,2.723,0,0,0,6.53,9.16V24.11Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2043"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    cx: 5.44,
    cy: 5.44,
    r: 5.44,
    transform: "translate(14.69 13.23)",
    fill: "#0ee359"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M22.52,17.16,19.5,20.18l-1.37-1.37",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.36
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3301",
    "data-name": "Group 3301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M30.43,16l-.09,10.03a2.859,2.859,0,0,1-2.86,2.86H12.76A2.859,2.859,0,0,1,9.9,26.03",
    fill: "none",
    stroke: "#2a6bec",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M9.91,26.03V11.31a2.859,2.859,0,0,1,2.86-2.86H27.49a2.859,2.859,0,0,1,2.86,2.86",
    fill: "none",
    stroke: "#2a6bec",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3302",
    "data-name": "Group 3302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M5.78,23.31V8.59A2.859,2.859,0,0,1,8.64,5.73H23.36a2.859,2.859,0,0,1,2.86,2.86",
    fill: "none",
    stroke: "#2a6bec",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M9.64,26.17h-1a2.859,2.859,0,0,1-2.86-2.86",
    fill: "none",
    stroke: "#2a6bec",
    strokeWidth: 1.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M21.81,5.29a2.784,2.784,0,0,1,.06.58",
    fill: "#165cf3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M6.11,23.45H4.29a2.859,2.859,0,0,1-2.86-2.86V5.87A2.859,2.859,0,0,1,4.29,3.01H19.01a2.863,2.863,0,0,1,2.8,2.28",
    fill: "none",
    stroke: "#2a6bec",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(29.86 13.23)",
    fill: "#2a6bec"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettinngsVersionIcon);
export default __webpack_public_path__ + "static/media/settinngs-version-icon.4119f9a2b83cf7a02f1ae43083a7ba31.svg";
export { ForwardRef as ReactComponent };